import { useContext } from 'react';
import { CustomerConfigContext } from '../providers/CustomerConfigProvider';
function useCustomerConfig() {
    return useContext(CustomerConfigContext);
}
export default useCustomerConfig;
